import { authAxiosRequest } from 'api/axios';
import { Session } from '../resources';

export type GetSessionsForUserResponse = {
  data: Session[];
};

export const getSessionsForUser = (userId: string) => {
  return authAxiosRequest<GetSessionsForUserResponse>(`/api/users/${userId}/sessions`);
};